import { render, staticRenderFns } from "./portfoliostrattable.vue?vue&type=template&id=72bb93f0&scoped=true&"
import script from "./portfoliostrattable.vue?vue&type=script&lang=js&"
export * from "./portfoliostrattable.vue?vue&type=script&lang=js&"
import style0 from "./portfoliostrattable.vue?vue&type=style&index=0&id=72bb93f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bb93f0",
  null
  
)

export default component.exports